import React, { useState } from 'react';
import ProgressSteps from './progressSteps';
import statusIcon from "../../assets/status.png"
import { NavLink } from 'react-router-dom';

const StepFour = ({setStepFromUrl}) => {

    return (
        <div>
            <ProgressSteps currentStep={4} />
            <div className='py-4'>
            <div className='text-center p-4 ' style={{background:"#F8F8F8", width: "600px", margin:"50px auto"}}>
                <img src={statusIcon} alt='' style={{ width:"40px", height:"40px"}} />
                <h5 className="my-3 sub-title">Your payroll setup is complete</h5>
                <p className='gray-text-for-content m-0'>Select any of the categories to the top to update your information.</p>
            </div>
            </div>

            <div className="text-center mt-4">
                <button
                    type="button"
                    onClick={() => setStepFromUrl(1)}
                    className="cancel-button px-4 mx-2 text-decoration-none"
                >
                    Back to edit
                </button>
                <NavLink type="button" to={'/manage-employee'} className="dark-orange-button px-4 text-decoration-none">
                Okay!
                </NavLink>
            </div>
        </div>
    );
};

export default StepFour;